import { createApi } from '@reduxjs/toolkit/dist/query/react';
import {
  CacheTags,
  ClientAdminRequest,
  SomeRequest,
} from 'types';
import { RoleResponse } from './bindings/RoleResponse';
import { Role } from './bindings/Role';
import { FetchResponse } from './bindings/FetchResponse';
import { OdinBaseQuery } from './core';
import { PostRoleRequest } from './bindings/PostRoleRequest';
import { PutRoleRequest } from './bindings/PutRoleRequest';

export const rolesApi = createApi({
  reducerPath: 'roles',
  baseQuery: OdinBaseQuery,
  tagTypes: [CacheTags.roles],
  endpoints: (builder) => ({
    postRole: builder.mutation<RoleResponse, PostRoleRequest>({
      query: (payload) => ({
        url: `/api/ca/roles`,
        method: 'POST',
        body: payload,
      }),
    }),
    putRole: builder.mutation<RoleResponse, PutRoleRequest>({
      query: (payload) => ({
        url: `/api/ca/roles`,
        method: 'PUT',
        body: payload,
      }),
    }),
    fetchClientRoles: builder.query<
      FetchResponse<RoleResponse>,
      ClientAdminRequest
    >({
      query: (payload) => ({
        url: '/api/ca/roles',
        method: 'GET',
        params: payload,
      }),
      providesTags: (data) => {
        let returnValue = [{ type: CacheTags.roles, id: CacheTags.partial }];

        if (data) {
          returnValue = [
            ...returnValue,
            ...data.items.map((x) => ({
              type: CacheTags.roles,
              id: x.id,
            })),
          ];
        }

        return returnValue;
      },
      // providesTags: (data) => [
      //   ...[{ type: CacheTags.roles, id: CacheTags.partial }],
      //   ...(data?.items.map((x) => ({
      //     type: CacheTags.roles,
      //     id: x.id.toString(),
      //   })) || []),
      // ],
    }),
    fetchSomeRoles: builder.query<FetchResponse<Role>, SomeRequest>({
      query: (payload) => ({
        url: '/api/ca/roles',
        method: 'GET',
        params: payload,
      }),
      providesTags: (data) => {
        let returnValue = [{ type: CacheTags.roles, id: CacheTags.partial }];

        if (data) {
          returnValue = [
            ...returnValue,
            ...data.items.map((x) => ({
              type: CacheTags.roles,
              id: x.id,
            })),
          ];
        }

        return returnValue;
      },
    }),
  }),
});

export const {
  usePostRoleMutation,
  usePutRoleMutation,
  useFetchClientRolesQuery,
  useFetchSomeRolesQuery,
} = rolesApi;
